import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { DropUp, Scrollbar, Fade } from '@mssgme/ui';
import QuickReplyItem, { replyType } from './QuickReplyItem';
import useQuickRepliesMatch from './useQuickRepliesMatch';

import styles from './QuickRepliesMatch.scss';

PureQuickRepliesMatch.propTypes = {
    isOpen: PropTypes.bool,
    items: PropTypes.arrayOf(replyType).isRequired,
    onSelectItem: PropTypes.func,
};

PureQuickRepliesMatch.defaultProps = {
    isOpen: false,
};

export function PureQuickRepliesMatch({ isOpen, items, onSelectItem }) {
    const { t } = useTranslation('inbox');

    return (
        <>
            <Fade in={isOpen} duration="normal">
                <div className={styles.backdrop} />
            </Fade>
            <DropUp in={isOpen} duration="normal">
                <div className={styles.root}>
                    <header className={styles.header}>
                        <h3 className={styles.title}>{t('QuickRepliesMatchPopup.title')}</h3>
                    </header>
                    <Scrollbar>
                        <div className={styles.content}>
                            <ul className={styles.list}>
                                {items.map((item) => (
                                    <QuickReplyItem data={item} key={item._id} onSelect={onSelectItem} />
                                ))}
                            </ul>
                        </div>
                    </Scrollbar>
                </div>
            </DropUp>
        </>
    );
}

export default function QuickRepliesMatch(props) {
    const state = useQuickRepliesMatch();

    return <PureQuickRepliesMatch {...state} {...props} />;
}
